define('ROOM4.CCAProductGallery.CCAProductGallery.Collection', [
    'Backbone',
    'Utils'
], function(
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Collection.extend({
        url: Utils.getAbsoluteUrl(
            getExtensionAssetsPath('Modules/CCAProductGallery/SuiteScript2/CCAProductGallery.Service.ss'),
            true
        ),

        parse: function parse(response) {
            response = response || {};

            this.currentPage = parseInt(response.page, 10) || 1;
            this.recordsPerPage = parseInt(response.recordsPerPage, 10) || 0;
            this.totalRecordsFound = parseInt(response.totalRecordsFound, 10) || 0;
            this.facets = response.facets || [];
            this.vehicleOptions = response.vehicleOptions || [];
            this.resolvedVehicleFilters = response.resolvedVehicleFilters || {};

            return response.records || [];
        }
    });
});
